import { render, staticRenderFns } from "./classificator.vue?vue&type=template&id=dba5fc96&scoped=true&"
import script from "./classificator.vue?vue&type=script&lang=js&"
export * from "./classificator.vue?vue&type=script&lang=js&"
import style0 from "./classificator.vue?vue&type=style&index=0&lang=css&"
import style1 from "./classificator.vue?vue&type=style&index=1&id=dba5fc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba5fc96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dba5fc96')) {
      api.createRecord('dba5fc96', component.options)
    } else {
      api.reload('dba5fc96', component.options)
    }
    module.hot.accept("./classificator.vue?vue&type=template&id=dba5fc96&scoped=true&", function () {
      api.rerender('dba5fc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/search/classificator.vue"
export default component.exports